export default {
    business: {
        create: {
            title: 'Create  New Business Account',
            subtitleBusinessInformation: 'Business Information',
            subtitleCapacity: 'Capacity',
            hintCapacity:
                'Max Capacity field is Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            successMessage: 'New Business has been added'
        },
        goals: {
            title: 'Business Goals',
            consecutiveDays: {
                switchLabel: 'Consecutive Days Meditated',
                params: [
                    {
                        label: '3 days',
                        value: '3_daily_watch'
                    },
                    {
                        label: '5 days',
                        value: '5_daily_watch'
                    },
                    {
                        label: '10 days',
                        value: '10_daily_watch'
                    }
                ]
            }
        },
        edit: {
            title: 'Edit Business Account',
            subtitle: 'Business Information',
            successMessage: 'Business Information Updated',
            successMessageAvatar: 'Business Logo Updated',
            successMessageAvatarDeleted: 'Business Logo Deleted',
            upload: {
                button: 'Upload Image'
            },
            settings: {
                title: 'Account Settings',
                uploadTitle: 'Upload Logo Image',
                deactivate: {
                    title: 'Deactivate Account',
                    description:
                        'When you deactivate their account, the Business information will be saved, but they will no longer be able to access the Chill App. Ready to jump back in? Click the toggle to reactivate their account.',
                    successMessageActivated: 'The account has been Activated',
                    successMessageDeactivated:
                        'The account has been Deactivated'
                },
                delete: {
                    title: 'Delete Account',
                    description:
                        'Click the button below to delete their account which will permanently remove the Manager’s access to and information from the Chill App.',
                    button: 'Delete account',
                    successMessage: 'The account has been deleted'
                },
                reset: {
                    title: 'Reset Password',
                    description:
                        'Click the button below, and a password reset link will be automatically sent to their email address. They’ll be back on the Chill App in no time.',
                    button: 'Reset password',
                    successMessage: 'The account has been reseted'
                }
            },
            confirmation: {
                delete: {
                    title: 'Delete Account',
                    description:
                        'Are you sure you want to permanently delete this Business account?'
                }
            }
        },
        list: {
            title: 'Business Accounts',
            createButton: 'add business',
            createButtonMobile: 'add',
            status: {
                active: 'Active',
                inactive: 'Inactive',
                temporary: 'Trial'
            },
            programTitle: {
                custom: 'Custom',
                challenge: 'Challenge'
            }
        },
        setPassword: {
            title: 'Set Password for Members',
            description:
                'Sets this password for every member of the business who has not set their own password yet. Members who already have a password are left unchanged.',
            passwordField: 'Password',
            save: 'Set password',
            cancel: 'Cancel',
            successMessage:
                'Password set for {count} member(s) without a password',
            noneAffected: 'No members needed a password — nothing changed'
        },
        push: {
            title: 'Send Push Notification to All Members',
            titleField: 'Title',
            messageField: 'Message',
            sessionField: 'Session ID to open on tap (optional)',
            mindfulMomentField: 'Mindful moment ID to open on tap (optional)',
            targetHint:
                'Fill at most one — leave both empty to just open the app.',
            send: 'Send',
            cancel: 'Cancel',
            successMessage: 'Push notification sent to all members',
            noDevicesError:
                'No members of this business have registered devices'
        },
        tableHeaders: [
            { text: 'Date', value: 'createdAt' },
            { text: 'Business Name ', value: 'name' },
            { text: 'Contact Name', value: 'owner.fullName' },
            {
                text: 'Date Range',
                value: 'program.startedAt',
                sortable: false
            },
            {
                text: 'Status',
                value: 'isActive',
                sortable: false,
                filter: [
                    {
                        title: 'All',
                        value: null
                    },
                    {
                        title: 'Active',
                        value: true
                    },
                    {
                        title: 'Inactive',
                        value: false
                    }
                ]
            },
            { text: 'Max', value: 'maxUsers', sortable: false },
            { text: 'Action buttons', class: 'actions', sortable: false }
        ],
        mobile: {
            sort: {
                date: 'Date Create'
            },
            filter: {
                status: {
                    name: 'Filter by Status',
                    filter: [
                        {
                            text: 'All',
                            value: null
                        },
                        {
                            text: 'Active',
                            value: true
                        },
                        {
                            text: 'Inactive',
                            value: false
                        }
                    ]
                }
            }
        }
    }
};
